// Photos data

const beforeAfterImages = [
    { name: "Casa_1", category: "Interior Painting" },
    { name: "cocina", category: "Interior Painting" },
    { name: "kitchen", category: "Interior Painting" },
    { name: "escalera", category: "Interior Painting" },
    { name: "mueble", category: "Interior Painting" },
    { name: "bookshelf", category: "Interior Painting" },
    { name: "tv-console", category: "Interior Painting" },
    { name: "Casa_2", category: "Interior Painting" },
    { name: "Casa_3", category: "Interior Painting" },
    { name: "Casa_4", category: "Interior Painting" },
    { name: "Casa_5", category: "Interior Painting" },
    { name: "Casa_6", category: "Interior Painting" },
    { name: "Casa_7", category: "Interior Painting" },
    { name: "Casa_8", category: "Interior Painting" },
    { name: "Casa_9", category: "Interior Painting" },
    { name: "Casa_10", category: "Interior Painting" },
    { name: "Casa_11", category: "Interior Painting" },
    { name: "corner_window", category: "Interior Painting" },
    // { name: "bano", category: "Interior Painting" },
    { name: "puerta", category: "Exterior Painting" },
    { name: "escaleras", category: "Exterior Painting" },
    { name: "main_entrance", category: "Exterior Painting" },
    { name: "Exterior_1", category: "Exterior Painting" },
    { name: "Exterior_2", category: "Exterior Painting" },
    { name: "Exterior_3", category: "Exterior Painting" },
    { name: "Exterior_4", category: "Exterior Painting" },
    { name: "Exterior_5", category: "Exterior Painting" },
    { name: "Exterior_6", category: "Exterior Painting" },
    { name: "Exterior_7", category: "Exterior Painting" },
    { name: "outdoor_stairs", category: "Exterior Painting" },
    // { name: "Exterior_8", category: "Exterior Painting" },
    { name: "bar", category: "Commercial Painting" },
    { name: "Local_1", category: "Commercial Painting" },
    { name: "Local_2", category: "Commercial Painting" },
    { name: "Local_3", category: "Commercial Painting" },
    { name: "Oficina_1", category: "Commercial Painting" },
    { name: "Oficina_2", category: "Commercial Painting" },
    { name: "Oficina_3", category: "Commercial Painting" },
    { name: "Taller_1", category: "Commercial Painting" },
    { name: "commercial-main-entrance", category: "Commercial Painting" },
    { name: "porche", category: "Deck Services" },
    { name: "deck-v2", category: "Deck Services" },
    { name: "deck", category: "Deck Services" },
    { name: "Deck_1", category: "Deck Services" },
    { name: "Deck_2", category: "Deck Services" },
    { name: "Deck_3", category: "Deck Services" },
];

export default beforeAfterImages;